import { render } from "./AddTask.vue?vue&type=template&id=3f2d8b1c&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"

import "./AddTask.vue?vue&type=style&index=0&id=3f2d8b1c&scoped=true&lang=css"

import exportComponent from "/Users/aryan/Task-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2d8b1c"]])

export default __exports__